import { AuthorContent } from '@silvertours/back-domain-page';
import {
  Wrapper,
  ImageWrapper,
  StyledImage,
  AuthorWrapper,
  AuthorText,
  AuthorTitle,
  AuthorName,
} from './Author.styles';

const Author = ({ name, text, image, role }: AuthorContent) => (
  <Wrapper id="author">
    <ImageWrapper>
      {image && <StyledImage src={image.src} alt="" width="128" height="128" />}
    </ImageWrapper>
    <AuthorWrapper>
      <AuthorTitle>{role}</AuthorTitle>
      <AuthorName>{name}</AuthorName>
      <AuthorText>{text}</AuthorText>
    </AuthorWrapper>
  </Wrapper>
);
export { Author };
